// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"bc297e8c","197":"260da7a0","254":"ae2bec06","334":"a6994d58","453":"d855a71b","644":"50e122ec","761":"dbb7a1a9","763":"7949eaa8","843":"41fe9c19"}[chunkId] + ".chunk.js";
};